class OTFControlColor {
    constructor() {
        $('input.alpha-color-control').alphaColorPicker();
    }
}